import BellIcon from '@assets/icons/bell.svg?react'
import CardsIcon from '@assets/icons/card.svg?react'
import InviteAndEarnIcon from '@assets/icons/invite-and-earn.svg?react'
import InvoicesIcon from '@assets/icons/invoices.svg?react'
import LockIcon from '@assets/icons/lock.svg?react'
import SavingsIcon from '@assets/icons/savings.svg?react'
import SupportIcon from '@assets/icons/support.svg?react'
import TransactionsIcon from '@assets/icons/transactions.svg?react'
import UserIcon from '@assets/icons/user.svg?react'
import UserCheckedIcon from '@assets/icons/user-checked.svg?react'
import type { NotificationCategory, NotificationChannel } from 'mmfintech-backend-api/types'
import type { ComponentType } from 'react'

export const NOTIFICATION_CHANNELS: NotificationChannel[] = ['IN_APP', 'EMAIL', 'PUSH']

export const NOTIFICATION_CATEGORY_ICONS: Record<NotificationCategory, ComponentType> = {
  SECURITY: LockIcon,
  ONBOARDING: UserCheckedIcon,
  ACCOUNT: UserIcon,
  CARDS: CardsIcon,
  TRANSACTIONS: TransactionsIcon,
  INVOICING_EXPENSES: InvoicesIcon,
  SAVINGS: SavingsIcon,
  SUPPORT_CHAT: SupportIcon,
  MARKETING_NEWS: InviteAndEarnIcon,
  INTERNAL: BellIcon
}

export const NOTIFICATION_CATEGORY_DESCRIPTIONS: Record<NotificationCategory, string> = {
  SECURITY: 'Login attempts, password changes, two-factor activity.',
  ONBOARDING: 'Account verification and setup steps.',
  ACCOUNT: 'Account status, IBANs, and user access changes.',
  CARDS: 'Card status changes and card activity.',
  TRANSACTIONS: 'Deposits, withdrawals and transfers. Notification center: already shown in your Transactions section.',
  INVOICING_EXPENSES: 'Invoice and expense status updates.',
  SAVINGS: 'Savings and overdraft account activity.',
  SUPPORT_CHAT: 'Support conversations and replies.',
  MARKETING_NEWS: 'Product news, offers and updates.',
  INTERNAL: 'Internal notifications.'
}
